import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {catchError} from 'rxjs/operators';
import {NavigationService} from '../services/nav/navigation.service';
import {JwtService} from '../services/user/jwt.service';
import {logUtishaError, logUtishaInfo} from '../util/log';

@Injectable({
  providedIn: 'root'
})
export class UnauthorizedInterceptor implements HttpInterceptor {

  constructor(private navService: NavigationService,
              private jwt: JwtService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith(environment.apiUrl)) {
      // @ts-ignore
      return next.handle(req).pipe(catchError(
        error => {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            this.jwt.refresh()
              .then(() => this.refreshAfterUnauth(req.url))
              .catch((err) => this.handleJwtRefreshError(err));
          }
          return throwError(error);
        }));
    }
    return next.handle(req);
  }

  private handleJwtRefreshError(err: any) {
    if (this.navService.isNavigationAllowed()) {
      logUtishaError('Error during jwt refresh, navigating to login page: ', err);
      return this.navService.login();
    } else {
      logUtishaError('Error during jwt refresh, do NOT navigate to login page: ', err);
    }
  }

  private refreshAfterUnauth(url: string) {
    if (this.navService.isNavigationAllowed()) {
      logUtishaInfo(`Unauthorized (${url}): browser refresh page`);
      window.location.reload();
    } else {
      logUtishaInfo(`Unauthorized (${url}): do NOT refresh page`);
    }
  }

}
